import { render } from "./SignUpComponent.vue?vue&type=template&id=5fefe4ca&scoped=true"
import script from "./SignUpComponent.vue?vue&type=script&lang=js"
export * from "./SignUpComponent.vue?vue&type=script&lang=js"

import "./SignUpComponent.vue?vue&type=style&index=0&id=5fefe4ca&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fefe4ca"]])

export default __exports__